import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div className="legal-page page-shell">
      <div className="card legal-card">
        <h1>Privacy Policy</h1>
        <p className="muted">Last updated: July 23, 2026</p>

        <p>
          This Privacy Policy explains how MyFarmingPal collects, uses, stores,
          and shares information when people use our website, marketplace, job
          listings, messaging, profiles, reviews, farm records, events, and
          related features.
        </p>

        <h2>1. Information Users May Provide</h2>
        <p>
          Users may provide account information such as name, email address,
          phone number if added, account type, roles, profile information,
          notification preferences, and profile photos.
        </p>

        <p>
          Users may also provide listings, product details, prices, photos,
          descriptions, availability, reviews, messages, event information,
          bids, applications, farm stand details, and general location or
          service-area information.
        </p>

        <p>
          Farm Records may include private information a user chooses to save,
          such as fields, livestock, inventory, equipment, crop records, tasks,
          expenses, contacts, notes, photos, dates, and related farm details.
        </p>

        <h2>2. Public and Private Content</h2>
        <p>
          Public content is only what users choose to post publicly, such as
          public profiles, marketplace listings, job listings, farm stand
          listings, community posts, event listings, photos, ratings, and
          reviews.
        </p>

        <p>
          Private Farm Records are private to the user account. They are not
          shown as public marketplace, profile, job, community, or event content
          unless the user separately chooses to create a public listing or post.
        </p>

        <h2>3. Location Information</h2>
        <p>
          Users may provide city, county, state, general area, pickup area,
          address, coordinates, field boundaries, or other location-related
          information. MyFarmingPal may use location information to show nearby
          listings, jobs, products, events, profiles, maps, distance estimates,
          and location-based search results.
        </p>

        <h2>4. How MyFarmingPal Uses Information</h2>
        <p>MyFarmingPal may use information to:</p>

        <ul>
          <li>Create, manage, and protect user accounts.</li>
          <li>Operate listings, messages, profiles, reviews, requests, and Farm Records.</li>
          <li>Show nearby jobs, products, farm stands, events, and community members.</li>
          <li>Send notifications when users enable them.</li>
          <li>Respond to support requests, privacy questions, reports, and safety concerns.</li>
          <li>Secure, troubleshoot, improve, and support the platform.</li>
          <li>Prevent fraud, spam, abuse, unauthorized access, and misuse.</li>
          <li>Comply with legal obligations and enforce platform rules.</li>
        </ul>

        <h2>5. How Information May Be Shared</h2>
        <p>
          Public posts and listings may be visible to other users and visitors.
          Messages are intended for conversation participants and may be reviewed
          if needed for safety, abuse prevention, support, or legal reasons.
        </p>

        <p>
          MyFarmingPal may use service providers to host, store, authenticate,
          secure, analyze, and operate the platform. These providers may process
          information only as needed to provide their services to MyFarmingPal.
        </p>

        <p>MyFarmingPal does not sell users' personal data.</p>

        <h2>6. Government Status</h2>
        <p>
          MyFarmingPal is not a government program and is not
          government-operated. MyFarmingPal does not decide eligibility for any
          government benefits, permits, payments, disaster programs, or
          agricultural programs.
        </p>

        <h2>7.Browser Storage and Similar Technologies </h2>
        <p>
          MyFarmingPal may use local storage, session storage, and similar browser technologies for limited technical functions, user interface choices, and operation of requested platform features.

MyFarmingPal does not currently use Google Analytics, advertising cookies, or cross-site tracking technologies.

Certain third-party services, such as Google Maps or Stripe, may use cookies or similar technologies when their related features are loaded or used. Their use of these technologies is governed by their respective privacy policies.
        </p>

        <h2>8. Data Security</h2>
        <p>
          MyFarmingPal uses technical and organizational measures designed to
          protect user information. No online service can guarantee perfect
          security, and users are responsible for keeping their login
          credentials secure.
        </p>

        <h2>9. Data Retention</h2>
        <p>
          MyFarmingPal may keep information as long as needed to operate,
          secure, improve, and support the platform, comply with legal
          obligations, resolve disputes, prevent abuse, and maintain records.
          Some information may remain in backups or logs for a limited period
          after deletion.
        </p>

        <h2>10. User Choices and Requests</h2>
        <p>
          Users may update certain account and profile information through their
          account settings. Users can contact MyFarmingPal through the{" "}
          <Link to="/contact">Contact page</Link> for privacy questions,
          account concerns, data-related requests, or account deletion help.
        </p>

        <h2>11. Children</h2>
        <p>
          MyFarmingPal is intended for users who are at least 18 years old. We
          do not knowingly allow children under 18 to create accounts.
        </p>

        <h2>12. Adult-Managed Minor Information</h2>
        <p>
          MyFarmingPal accounts are intended for adults age 18 and older. If a
          parent or legal guardian uses their own account to help a teenager
          look for local opportunities, the adult account holder is responsible
          for any information they choose to provide and should avoid posting
          unnecessary personal information about minors publicly. Teenagers
          should not create their own MyFarmingPal accounts.
        </p>

        <h2>13. Changes to This Privacy Policy</h2>
        <p>
          MyFarmingPal may update this Privacy Policy from time to time.
          Continued use of the platform after an updated policy is posted means
          users acknowledge the updated policy.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
